/**
 * Reporting School Years Service (React)
 * Loads the same displayed choices as assets/js/services/reportingSchoolYearsService.js.
 * React uses a unique ID for each choice because current and archived options can share a year.
 */

const API_SERVER = process.env.API_SERVER || '';

export interface ReportingSchoolYearEntry {
  id: string | number;
  name: string;
  value: number;
  archived: boolean;
}

/**
 * Returns the list of reporting school years.
 * @returns Promise resolving to the React reporting school-year choices.
 */
export async function getReportingSchoolYears(): Promise<ReportingSchoolYearEntry[]> {
  const response = await fetch(`${API_SERVER}/reports/report_years`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch reporting school years: ${response.status} ${response.statusText}`);
  }

  return response.json() as Promise<ReportingSchoolYearEntry[]>;
}

const reportingSchoolYearsService = {
  get: getReportingSchoolYears,
};

export default reportingSchoolYearsService;
